// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelwidth{
    padding: 13px;
    width: 100%;
}

.parentNode {
    cursor: default;
}

.childNode {
    cursor: pointer;
}

    .childNode:hover {
        background-color: grey;
    }

.selectedNode, .selectedNode:hover {
    background-color: #97bf0d;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menutabs/datadescription/datadescription.menu.tab.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ;IACI,yBAAyB;AAC7B","sourcesContent":[".labelwidth{\n    padding: 13px;\n    width: 100%;\n}\n\n.parentNode {\n    cursor: default;\n}\n\n.childNode {\n    cursor: pointer;\n}\n\n    .childNode:hover {\n        background-color: grey;\n    }\n\n.selectedNode, .selectedNode:hover {\n    background-color: #97bf0d;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
